import { makeStyles } from "@fluentui/react-components";

export const useClauseDiffHighlighterStyles = makeStyles({
  preWrapped: {
    whiteSpace: "pre-line",
    wordBreak: "break-word",
  },
  insert: {
    color: "blue",
  },
  delete: {
    color: "red",
  },
});
